import Layout from "../../components/Layout";
import { defaultURL, bayarOtomatisMeta } from "../../data/DataMetatags";
import NextHead from "../../components/Seo/NextHead";
import BreadcrumbComponent from "../../components/UserInterface/BreadcrumbComponent";
import { bayarOtomatisBreadcrumb } from "../../data/DataBreadcrumb";
import {
  DirectDebitHeader,
  DirectDebitWrapper,
  DirectDebitInformation,
  DirectDebitStepsContent
} from "src/views/bayar-otomatis";
import dynamic from "next/dynamic";

const Widget = dynamic(
  () => import("../../components/Widget"),
  {
    ssr: false
  }
);

const BayarOtomatis = ({ pageTitle, descriptionSEO, asPath, breadcrumb }) => {
  return (
    <Layout>
      <NextHead
        title={pageTitle}
        description={descriptionSEO}
        url={asPath}
        breadcrumb={breadcrumb}
      />
      <Widget asPath={asPath} />
      <BreadcrumbComponent items={bayarOtomatisBreadcrumb} />
      <DirectDebitWrapper>
        <DirectDebitHeader />
        <DirectDebitInformation />
        <DirectDebitStepsContent />
      </DirectDebitWrapper>
    </Layout>
  );
};

BayarOtomatis.getInitialProps = ({ asPath }) => {
  const pageTitle = bayarOtomatisMeta.title;
  const descriptionSEO = bayarOtomatisMeta.description;
  const breadcrumb = [
    {
      "@type": "ListItem",
      position: "1",
      item: {
        "@id": defaultURL,
        name: "Home"
      }
    },
    {
      "@type": "ListItem",
      position: "2",
      item: {
        "@id": defaultURL + asPath,
        name: pageTitle
      }
    }
  ];
  return { pageTitle, descriptionSEO, asPath, breadcrumb };
};

export default BayarOtomatis;
